import { ChangeEvent, useEffect, useState, FocusEvent } from "react"

import { MbaConfiguration } from "models/mba"
import { TextInput } from "components/inputs/TextInput"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"

type Props = {
  data?: string
  update: (variables: MbaConfiguration) => void
  id?: string
  disabled?: boolean
}

export function TermsAndConditions(props: Props) {
  const { t } = useI18n()
  const { data, id, update, disabled } = props
  const [terms, setTerms] = useState<string | undefined>(() => data)

  useEffect(() => {
    setTerms(data)
  }, [data])

  const handleChange = (
    evt: ChangeEvent<
      | HTMLInputElement
      | {
          name?: string | undefined
          value: string
        }
    >,
  ) => {
    const { name, value } = evt?.target
    !!name && setTerms(value)
  }

  const handleBlur = (
    event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    id &&
      update({
        terms: event.currentTarget.value || "",
        id,
      })
  }
  return (
    <div className={styles.container}>
      <h5 className="BodyBody-1BlackBold">{t("campaign.documents.terms")}</h5>
      <TextInput
        value={terms}
        id="termsAndConditions"
        name="termsAndConditions"
        variant="outlined"
        color="primary"
        onChange={handleChange}
        onBlur={handleBlur}
        rows={8}
        rowsMax={8}
        multiline
        style={{ width: "80%" }}
        disabled={disabled}
      />
    </div>
  )
}

const styles = {
  container: css`
    display: flex;
    min-width: 100%;
    flex-direction: column;
  `,
}
